export default "__VITE_ASSET__Bdo50PmP__"